import styled from 'styled-components';

export const RowIconContainer = styled.div`
  display: flex;
  gap: 15px;
  align-items: center;
`;

export const RowIconWrapper = styled.div`
  background: ${({ $bg }) => $bg};
  width: ${({ $size }) => $size}px;
  height: ${({ $size }) => $size}px;
  border-radius: 14px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const RowIconText = styled.p`
  font-weight: 600;
  font-size: 14px;
  color: #0f172b;
`;
